import { TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';

const StyledContainer = styled(TransitionGroup).attrs({
	'data-hud-quests': 'true',
})`
	position: absolute;
	top: 178px;
	right: 30px;
	display: flex;
	flex-direction: column;
	row-gap: 20px;
	user-select: none;
	pointer-events: none;
`;

export { StyledContainer };
